import { match } from "@formatjs/intl-localematcher";
import Negotiator from "negotiator";

export const locales = ["en", "es"];

// Get the preferred locale, similar to the above or using a library
export function getLocale() {
  const headers = { "accept-language": locales.join(",") };
  const languages = new Negotiator({ headers }).languages();

  const defaultLocale = "en";

  return match(languages, locales, defaultLocale);
}
